module.exports = __webpack_public_path__ + "static/media/510df0e5-5b9f-4a1c-b46a-bcf1739bda43.18ef53ea.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274151/510df0e5-5b9f-4a1c-b46a-bcf1739bda43.woff
// module id = 1666
// module chunks = 2